<template>
  <div>
    <div v-if="!widget.embedMode">
      <v-sheet
        color="primary"
        :dark="!$vuetify.theme.isDark"
        class="d-flex align-items-center py-1"
      >
        <div class="flex-fill"></div>
        <div class="d-flex align-center px-2">
          <div v-if="systemBarConfig.data.minimize">
            <v-btn
              elevation="0"
              icon
              small
              @click="minimize"
            >
              <Icon
                icon="minus"
                :size="24"
                color="white"
              />
            </v-btn>
          </div>
          <div v-if="systemBarConfig.data.maximize">
            <v-btn
              elevation="0"
              icon
              small
              @click="$widget.maximizeToggler()"
            >
              <Icon
                :icon="widget.maximized ? 'fullscreen-exit' : 'fullscreen'"
                :size="18"
                color="white"
              />
            </v-btn>
          </div>
          <div v-if="systemBarConfig.data.close">
            <Confirm
              ref="confirm"
              :title="$t('systemBar.confirmModal.title')"
              :detail="$t('systemBar.confirmModal.detail')"
              :action="$t('systemBar.confirmModal.action')"
              :globalExit="true"
              @confirmHandler="leave"
            />
            <v-btn
              elevation="0"
              icon
              small
              @click="$refs.confirm.toggleConfirm()"
            >
              <Icon
                icon="close"
                :size="20"
                color="white"
              />
            </v-btn>
          </div>
          <div v-if="systemBarConfig.data.more.active">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  elevation="0"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <Icon
                    icon="dots-vertical"
                    :size="22"
                    color="white"
                  />
                </v-btn>
              </template>
              <v-list
                nav
                dense
                class="pa-0 px-2"
              >
                <v-list-item
                  v-if="systemBarConfig.data.more.options.align"
                  class="ma-0"
                >
                  <div class="d-flex align-center">
                    <div class="mr-2">
                      <small>{{ $t('systemBar.align') }}</small>
                    </div>
                    <div>
                      <div>
                        <v-btn
                          small
                          icon
                          color="transparent"
                          @click="$widget.align('left')"
                        >
                          <Icon
                            icon="format-align-left"
                            color="#333"
                            :size="18"
                          />
                        </v-btn>
                        <v-btn
                          small
                          icon
                          color="transparent"
                          @click="$widget.align('center')"
                        >
                          <Icon
                            icon="format-align-center"
                            color="#333"
                            :size="18"
                          />
                        </v-btn>
                        <v-btn
                          small
                          icon
                          color="transparent"
                          @click="$widget.align('right')"
                        >
                          <Icon
                            icon="format-align-right"
                            color="#333"
                            :size="18"
                          />
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-list-item>
                <v-divider v-if="systemBarConfig.data.more.options.close"></v-divider>
                <v-list-item
                  v-if="systemBarConfig.data.more.options.close"
                  @click="$refs.confirm.toggleConfirm()"
                >
                  <Icon
                    color="#333"
                    icon="close"
                    :size="20"
                    class="mr-2"
                  />
                  {{ $t('systemBar.exit') }}
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-sheet>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Confirm: () => import(/* webpackPrefetch: true */ '@/components/Confirm.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    room: {
      type: Boolean,
      default: false
    },
    queue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    systemBarConfig () {
      return this.$organization.systemBarConfig()
    },
    widget () {
      return this.$store.state.widget
    }
  }
})
export default class SystemBar extends Vue {
  data () {
    return {
      element: {
        height: 50
      }
    }
  }

  mounted () {
    if (this.$el && this.$el.querySelector('.v-system-bar')) {
      this.element.height = this.$el.querySelector('.v-system-bar').offsetHeight
    }
  }

  reset () {
    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: 'Botón salir de la vista del lobby.',
      detail: 'El cliente salió despues de intentar contactar a un agente.',
      actionType: 'FNAN',
      functionality: 11,
      historyInteractionType: 'LEFTLB'
    })

    this.$storage.initializeStorageData(true)
    if (this.$route.name !== 'home') {
      this.$router.replace({ path: '/' })
    }
  }

  minimize () {
    this.$widget.minimizeEvent()
    this.$widget.toggle(false)
  }

  async leave () {
    this.$widget.closeEvent()
    setTimeout(async () => {
      if (this.queue) {
        await this.$parent.leaveQueue(true)
      }

      if (!this.room) {
        this.$storage.initializeStorageData(true)
        setTimeout(() => {
          this.$router.replace({ path: '/' })
        }, 500)
      } else {
        this.$emit('finishSession', 'system-bar')
      }

      if (this.$organization.hideOnFinish()) {
        this.$widget.hide()
      } else {
        this.$widget.toggle(false)
      }
    }, 500)
  }
}
</script>
